import client from "./sharedoClient";

const check = (entityType, systemName) => client.get(`api/systemNames/${entityType}/${systemName}`);

export default {
    check
}